import axios from 'axios';

console.log(process.env.REACT_APP_NAME)
// https://demo.jeetho.srshta.com/api
 //const baseURL = 'http://localhost:5057/api';
    const baseURL = process.env.REACT_APP_APIURL;
const instance = axios.create({
  baseURL:baseURL,
  timeout: 500000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token;
  if ( localStorage.getItem("id_token")) {
    token =   localStorage.getItem("id_token");
  }
  // Merge headers instead of overwriting
  return {
    ...config,
    headers: {
      ...config.headers,
      ...(token && { authorization: `Bearer ${token}` }),
    },
  };
});

// console.log(process.env.API_BASE_URL);
const responseBody = (response) => response.data;

const requests = {
  get: (url, body) => instance.get(url, body).then(responseBody),

  post: (url, body, config = {}) => {
    // Merge custom headers with default headers
    const mergedConfig = {
      ...config,
      headers: {
        ...instance.defaults.headers,
        ...config.headers,
      },
    };
    return instance.post(url, body, mergedConfig).then(responseBody);
  },

  put: (url, body) => instance.put(url, body).then(responseBody),
  delete: (url, body) => instance.delete(url).then(responseBody),
  baseURL:() => baseURL ,
};

export default requests;
